import React, { useCallback } from 'react'
import BaseContactInput from './BaseContactInput'
import { validatePhone } from '@/utils/validation'

interface PhoneContactInputProps {
  isChecked: boolean
  onCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  phone: string
  onPhoneChange: (value: string, isValid: boolean) => void
  isSubmitting: boolean
  error?: string
}

const PhoneContactInput: React.FC<PhoneContactInputProps> = ({
  isChecked,
  onCheckboxChange,
  phone,
  onPhoneChange,
  isSubmitting,
  error
}) => {
  const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
    // Permitir: backspace, delete, tab, escape, enter y números
    if (
      ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key) || // Teclas de control
      (/[0-9]/.test(e.key) && !e.ctrlKey && !e.altKey && !e.metaKey) // Solo números
    ) {
      return
    }
    e.preventDefault()
  }, [])

  const handlePhoneChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value
      const isValid = value.trim() === '' ? true : validatePhone(value)
      onPhoneChange(value, isValid)
    },
    [onPhoneChange]
  )

  const handleBlur = useCallback(() => {
    if (isChecked) {
      const isValid = validatePhone(phone)
      onPhoneChange(phone, isValid)
    }
  }, [isChecked, phone, onPhoneChange])

  return (
    <BaseContactInput
      id="phone"
      label="Quiero que me contacten por teléfono"
      isChecked={isChecked}
      onCheckboxChange={onCheckboxChange}
      value={phone}
      onChange={handlePhoneChange}
      onBlur={handleBlur}
      error={error}
      isSubmitting={isSubmitting}
      inputProps={{
        type: 'tel',
        maxLength: 9,
        pattern: '[0-9]{9}',
        autoComplete: 'tel',
        onKeyDown: handleKeyDown
      }}
    />
  )
}

export default PhoneContactInput
